import { render, staticRenderFns } from "./Select-locale.vue?vue&type=template&id=6230c8a1&"
import script from "./Select-locale.vue?vue&type=script&lang=js&"
export * from "./Select-locale.vue?vue&type=script&lang=js&"
import style0 from "./Select-locale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VSpeedDial})
